import type {ISbStoryData} from 'storyblok-js-client';
import {isStoryblokSeoField, isStoryblokPublishField} from '../utils/meta';
import type {StoryblokFieldPublish, StoryblokFieldSeo} from '../types';
import {DateTime} from 'luxon';

export function useStoryblokStory(story: Ref<ISbStoryData | undefined> | ISbStoryData | undefined) {
  const storyData = toRef(story);

  const fields = computed(() => {
    const fields: {
      publish?: StoryblokFieldPublish
      seo?: StoryblokFieldSeo
    } = {};

    for (const field of Object.values(storyData.value?.content ?? {})) {
      if (isStoryblokSeoField(field)) {
        fields.seo = field;
      } else if (isStoryblokPublishField(field)) {
        fields.publish = field;
      }
    }

    return fields;
  });

  const publishedAt = computed(() => fields.value.publish
    ? (fields.value.publish.published_at
      ? DateTime.fromSQL(fields.value.publish.published_at)
      : undefined)
    : (storyData.value?.published_at
      ? DateTime.fromISO(storyData.value?.published_at)
      : undefined));

  const isPublished = computed(() => Boolean(
    !publishedAt.value
    || (publishedAt.value?.isValid && publishedAt.value <= DateTime.now()),
  ));

  return {
    seo: computed(() => fields.value.seo),

    isPublished,
    publishedAt,
  };
}
